import { SET_AVAILABLE_LICENSES, RESET_AVAILABLE_LICENSES } from './types';

// Try to get licenses from localStorage during initialization
const savedLicenses = localStorage.getItem("availableLicenses");
const initialState = {
    availableLicenses: savedLicenses ? JSON.parse(savedLicenses) : []
};

const licensesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_AVAILABLE_LICENSES:
            return {
                ...state,
                availableLicenses: action.payload
            };
        case RESET_AVAILABLE_LICENSES:
            return {
                ...state,
                availableLicenses: []
            };
        default:
            return state;
    }
};

export default licensesReducer;
